import { useRef, useState } from "react"
import QuizSection from "./QuizSection"
import KeyTakeAway from "./KeyTakeAway"
import ChatSection from "./ChatSection"
import PersonalisedForYou from "./PersonalisedForYou"
import LearnTubeXIllustartion from "../../components/LearnTubeXIllustartion"
import { useSelector } from "react-redux"
import { selectSubscriptionStatus } from "../../redux/subscriptionStatusSlice"
import { selectBottomIllustationStatus } from "../../redux/bottomIllustration"
import { selectAuthentication } from "../../redux/authenticationSlice"
import { selectCourseList } from "../../redux/courseListSlice"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamation } from "@fortawesome/free-solid-svg-icons"


const DesktopOtherSection = ({ lessonName, userGoal, setUserGoal, course_slug, lesson_slug, module_slug, lessonDetails, quizRef }) => {

    const subscriptionStatus = useSelector(selectSubscriptionStatus)
    const bottomIllustrationStatus = useSelector(selectBottomIllustationStatus)
    const authentication = useSelector(selectAuthentication)
    const subject_name = useSelector(selectCourseList)?.courseName

    const [ showKeyPoints, setShowKeyPoints ] = useState(false)
    const [ showQuiz, setShowQuiz ] = useState(true)
    const [ showAskCreator, setShowAskCreator ] = useState(false)
    const [isAtEnd, setIsAtEnd] = useState(false);

    const sentinelRef1 = useRef(null)
    
    const handleToggle = (index) => {
        if (index === 0){
            setShowQuiz(true)
            setShowAskCreator(false)
            setShowKeyPoints(false)
        }else if (index === 1){
            setShowQuiz(false)
            setShowAskCreator(false)
            setShowKeyPoints(true)
        }else if (index === 2){
            setShowQuiz(false)
            setShowAskCreator(true)
            setShowKeyPoints(false)
        }
    }

    return (
        <div className='w-full flex flex-col lg:mt-5 lg:px-6 pb-4 lg:pb-6'>
            <h3 className="text-2xl max-lg:hidden font-medium">{lessonName}</h3>
            <div className="mt-4 flex gap-3 overflow-x-scroll border-b border-[#365C7D] max-lg:justify-between max-lg:px-2 max-lg:text-center">
                <div className={`reactour-desktop-quizsection reactour-quizsection flex cursor-pointer items-center justify-center pb-3 text-xl leading-5 lg:w-[175px] max-lg:flex-1 max-lg:text-sm ${showQuiz ? 'border-b-4 border-[#7FC241] font-bold text-[#7FC241]' : 'text-[#8FB0CB]'}`} onClick={() => handleToggle(0)}>
                    <h3>Quiz</h3>
                    {(lessonDetails?.lesson_status !== 'completed') && <div className="w-5 h-5 ml-2 rounded-full border-2 border-[#F59E0B] flex items-center justify-center "><FontAwesomeIcon icon={faExclamation} className="text-sm text-[#F59E0B]" /></div>}
                </div>
                <div className={`reactour-desktop-keypoints reactour-keypoints flex cursor-pointer items-center justify-center pb-3 text-xl leading-5 lg:w-[175px] max-lg:flex-1 max-lg:text-sm ${showKeyPoints ? 'border-b-4 border-[#7FC241] font-bold text-[#7FC241]' : 'text-[#8FB0CB]'}`} onClick={() => handleToggle(1)}>
                    <h3>Key Takeways</h3>
                </div>
                <div className={`reactour-desktop-chatsection reactour-chatsection flex cursor-pointer items-center justify-center pb-3 text-xl leading-4 lg:w-[175px] max-lg:flex-1 max-lg:text-sm ${showAskCreator ? 'border-b-4 border-[#7FC241] font-bold text-[#7FC241]' : 'text-[#8FB0CB]'}`} onClick={() => handleToggle(2)}>
                    <h3>Ask The Creator</h3>
                </div>
            </div>
            <div ref={quizRef}>
                {showQuiz && <QuizSection
                    userGoal={userGoal}
                    setUserGoal={setUserGoal}
                    course_slug={course_slug}
                    lesson_slug={lesson_slug}
                    module_slug={module_slug}
                />}
                {showKeyPoints && <div className="mt-5 rounded-xl relative reactour-keypoints px-4">
                    <div className='hidden justify-between items-center'>
                        <h2 className='text-2xl font-semibold'>Key Takeaways</h2>
                        <PersonalisedForYou/>
                    </div>
                    <div className="mt-3 rounded-lg border border-white/10 bg-gradient-to-br from-[#17395A] to-[#102D47]">
                        <KeyTakeAway
                            course_slug={course_slug}
                            userGoal={userGoal}
                            setUserGoal={setUserGoal}
                            lesson_slug={lesson_slug}
                            module_slug={module_slug}
                        />
                    </div>
                </div>}
                {showAskCreator && <>
                    <div className='flex items-center justify-between px-4 mt-5 mb-3'>
                        <h2 className='text-2xl font-semibold flex-1'>Ask The Creator</h2>
                    </div>
                    <div className="px-4">
                        <ChatSection
                            lesson_id={lessonDetails?.lesson_id}
                            module_slug={module_slug}
                            course_slug={course_slug}
                            video_id={lessonDetails?.video_url?.split("?")?.[1]?.split("=")?.[1]}
                            lessonDetails={lessonDetails}
                        />
                    </div>
                </>}
            </div>
            {subscriptionStatus?.type === 'course_purchased' || bottomIllustrationStatus?.show_banner ? <div className='p-4 lg:hidden'>
                <LearnTubeXIllustartion
                    sentinelRef={sentinelRef1}
                    isAtEnd={isAtEnd}
                    setIsAtEnd={setIsAtEnd}
                    course_slug={subject_name}
                    authentication={authentication}
                />
            </div> : <div className='w-full h-4'></div>}
        </div>
    )
}

export default DesktopOtherSection
